import React, { useMemo, useState, useEffect, useRef } from 'react';
import debounce from 'lodash.debounce';
import TopHeader from './TopHeader';
import MainHeader from './MainHeader';
import './Header.scss';
import PreviewBar from '../preview-bar/PreviewBar';
import classNames from 'classnames';
import { graphql, useStaticQuery } from 'gatsby';
import { HeaderContext } from '../../context/headerContext';
import HighlightTopPage from '../highlight-top-page/HighlightTopPage';

function Header({ settings, bannerTop }) {
  const { menuTopHeaderBusinessPages } = useStaticQuery(
    graphql`
      {
        menuTopHeaderBusinessPages: allLiferayMenuHeaderTop(
          filter: {
            liferayFields: { title: { eq: "Menu - Top - Header - Main" } }
          }
        ) {
          nodes {
            liferayFields {
              langCode
            }
            topHeaderBusiness {
              content {
                leftSectionBusiness {
                  content {
                    labelLinkBusinessLeft {
                      value
                      content {
                        iconSvgIdBusinessLeft {
                          content {
                            iconThicknessLeft {
                              value
                            }
                          }
                          value
                        }
                        checkIconBusinessLeft {
                          value
                        }
                        linkInternalBusinessLeft {
                          value {
                            ... on LiferayPageGeneric {
                              link
                              pageTitle {
                                value
                              }
                            }
                            ... on LiferayModuleDetailProduct {
                              link
                              pageTitle: detailPageTitle {
                                value
                              }
                            }
                            ... on LiferayModuleDetailBlog {
                              link
                              pageTitle: detailPageTitle {
                                value
                              }
                            }
                            ... on LiferayModuleDetailIniziative {
                              link
                              pageTitle: detailPageTitle {
                                value
                              }
                            }
                          }
                        }
                        linkExternalBusinessLeft {
                          value
                        }
                        linkNotVisibleBusinessLeft {
                          value
                        }
                        linkAsButtonBusinessLeft {
                          value
                        }
                      }
                    }
                  }
                }
                rightSectionBusiness {
                  content {
                    labelLinkBusinessRight {
                      value
                      content {
                        iconSvgIdBusinessRight {
                          content {
                            iconThicknessRight {
                              value
                            }
                          }
                          value
                        }
                        checkIconBusinessRight {
                          value
                        }
                        linkInternalBusinessRight {
                          value {
                            ... on LiferayPageGeneric {
                              link
                              pageTitle {
                                value
                              }
                            }
                            ... on LiferayModuleDetailProduct {
                              link
                              pageTitle: detailPageTitle {
                                value
                              }
                            }
                            ... on LiferayModuleDetailBlog {
                              link
                              pageTitle: detailPageTitle {
                                value
                              }
                            }
                            ... on LiferayModuleDetailIniziative {
                              link
                              pageTitle: detailPageTitle {
                                value
                              }
                            }
                          }
                        }
                        linkExternalBusinessRight {
                          value
                        }
                        linkNotVisibleBusinessRight {
                          value
                        }
                        linkAsButtonBusinessRight {
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  );
  const [hasScrolled, sethasScrolled] = useState(false);

  const headerRef = useRef(null);
  const navigationMenuRef = useRef(null);

  const menuNodeBusiness = useMemo(() => {
    return menuTopHeaderBusinessPages.nodes.find(
      (node) => node.liferayFields.langCode === settings.langCode
    );
  }, [menuTopHeaderBusinessPages, settings.langCode]);

  useEffect(() => {
    const lastScrollTop = 0;

    const scrollListener = debounce(() => {
      const st = document.body.scrollTop || document.documentElement.scrollTop;

      if (st > lastScrollTop) {
        sethasScrolled(true);
      } else {
        sethasScrolled(false);
      }
    }, 250);

    document.addEventListener('scroll', scrollListener);

    return () => document.removeEventListener('scroll', scrollListener);
  }, []);

  return (
    <header
      ref={headerRef}
      className={classNames('header-wrapper', {
        'header-wrapper--landing': settings.pageType === 'landing',
      })}
      data-module-name='header'
      data-module-code='C-01'
    >
      {bannerTop && <HighlightTopPage data={bannerTop} />}
      {settings.pageType === 'business' && (
        <TopHeader
          showChangeLanguageButton={settings.showChangeLanguageButton}
          linkLangMap={settings.linkLangMap}
          langCode={settings.langCode}
          hasScrolled={hasScrolled}
          menuTopHeaderBusiness={menuNodeBusiness?.topHeaderBusiness?.content}
        />
      )}
      <HeaderContext.Provider
        value={{
          headerRef: headerRef,
          navigationMenuRef: navigationMenuRef,
        }}
      >
        <MainHeader
          ref={navigationMenuRef}
          pageType={settings.pageType}
          disableLinkLogo={settings.disableLinkLogo}
          langCode={settings.langCode}
          hasScrolled={hasScrolled}
          linkLangMap={settings.linkLangMap}
          link={settings.link}
          showChangeLanguageButton={settings.showChangeLanguageButton}
          hideSocialButton={settings.hideSocialButton}
          lateralStickerAnchor={settings.lateralStickerAnchor}
          menuTopHeaderBusiness={menuNodeBusiness?.topHeaderBusiness?.content}
        />
      </HeaderContext.Provider>

      {process.env.EDIT_MODE === 'true' && <PreviewBar />}
    </header>
  );
}

export default Header;
